import { intlLocale, t } from '@/i18n'

type Point = { at: string; value: number }

export function Sparkline({
  points,
  label,
  empty,
}: {
  points: Point[]
  label: string
  empty: string
}) {
  if (points.length === 0) {
    return <p className="mt-2 text-xs text-slate-500">{empty}</p>
  }
  const values = points.map((row) => row.value)
  const min = Math.min(...values)
  const max = Math.max(...values)
  const span = max - min || 1
  const w = 320
  const h = 72
  const pad = 4
  const coords = points.map((row, index) => {
    const x = pad + (index / Math.max(points.length - 1, 1)) * (w - pad * 2)
    const y = h - pad - ((row.value - min) / span) * (h - pad * 2)
    return `${x.toFixed(1)},${y.toFixed(1)}`
  })
  const last = points[points.length - 1]
  return (
    <div className="mt-2">
      <svg viewBox={`0 0 ${w} ${h}`} className="h-16 w-full" role="img" aria-label={label}>
        <polyline
          fill="none"
          stroke="#d4af37"
          strokeWidth="1.6"
          points={coords.join(' ')}
        />
      </svg>
      <p className="text-[11px] text-slate-500">
        {label}
        {last ? t('spark.last', { value: last.value.toLocaleString(intlLocale()) }) : ''}
      </p>
    </div>
  )
}
